import { Spin } from 'antd';
import { useLeadershipTier } from '@/hooks/useLeadershipTier';
import { ProjectReportDetailMobilePage } from '@/pages/mobile/shared/ProjectReportDetailMobilePage';

export function LeaderProjectReportDetailRoute() {
  const { isTopLeader, loading } = useLeadershipTier();

  if (loading) {
    return (
      <div className="mobile-card" style={{ textAlign: 'center', padding: 24 }}>
        <Spin />
      </div>
    );
  }

  return (
    <ProjectReportDetailMobilePage variant={isTopLeader ? 'top-leader' : 'leader'} />
  );
}
